import { render, staticRenderFns } from "./CryptoSection.vue?vue&type=template&id=a0747e8a&scoped=true"
import script from "./CryptoSection.vue?vue&type=script&lang=js"
export * from "./CryptoSection.vue?vue&type=script&lang=js"
import style0 from "./CryptoSection.vue?vue&type=style&index=0&id=a0747e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0747e8a",
  null
  
)

export default component.exports